module.exports = __webpack_public_path__ + "static/media/acrylic_thumb.f44a7226.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/acrylic_thumb.png
// module id = 1866
// module chunks = 0